import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LitigationDashboardService } from './litigation-dashboard.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ToastMessageService } from 'src/app/toastr.service';
import { environment } from 'src/environments/environment.prod';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { SortEvent } from 'primeng/api';
import { LazyLoadEvent } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-litigation-dashboard',
  templateUrl: './litigation-dashboard.component.html',
  styleUrls: ['./litigation-dashboard.component.scss']
})
export class LitigationDashboardComponent implements OnInit {
  litigationData: any[] = [];
  filteredLitigationData: any[] = [];
  loading = true;
  selectedOption: string = 'pdf'; // Default to 'pdf'
  isButtonDisabled: boolean = false;
  dropdownOptions = [
    { label: 'Found in PDF', value: 'pdf' },
    { label: 'Not Found in PDF', value: 'not_found' },
    { label: 'No Innovator (Defendants Directory)', value: 'defendants_directory' },
    { label: 'No Pdf And No Case No.', value: 'not_found_pdf_case_no' },
    { label: 'On Hold', value: 'on_hold' },
    { label: 'Deleted Records', value: 'deleted' },
    { label: 'Manual Entry', value: 'Manual Entry' },
    { label: 'Litigation Record By Excel', value: 'Pre_2017_Litigation_Excel' },
    { label: 'Appeal Cases', value: 'appeal_cases' },
    { label: 'Other Litigation', value: 'other_litigations' },
    { label: 'Other Litigation Appeal Cases', value: 'other_litigation_appeal_cases' }
  ];

  litigationCategoryOptions: any[] = [
    { label: 'NDA Vs NDA', value: 'NDA Vs NDA' },
    { label: 'ANDA Vs NDA', value: 'ANDA Vs NDA' },
    { label: 'ANDA Vs ANDA', value: 'ANDA Vs ANDA' },
    { label: 'Miscellaneous', value: 'Miscellaneous' }
  ];

  deletedScopeOptions = [
    { label: 'All', value: 'all' },
    { label: 'Main', value: 'main' },
    { label: 'Other', value: 'other' }
  ];
  deletedScope: string = 'all';

  addLitigationType: string = 'main';
  addLitigationCategory: string = 'NDA Vs NDA';
  displayDeleteDialog: boolean = false;
  recordToDelete: any;
  UserIp: any;
  email: any;
  selectedStatus: string | null = 'pending';
  selectedLitigationData: any[] = [];
  displayBulkRejectDialog: boolean = false;
  // showDeleteColumn: boolean = false;
  statusOptions = [
    { label: 'PENDING', value: 'pending' },
    { label: 'APPROVED', value: 'approved' },
    { label: 'REJECTED', value: 'rejected' },
  ];
  recordToHold: any;
  displayOnHoldDialog: any;
  startdate: Date | undefined;
  enddate: Date | undefined;
  dateError: string = '';
  displayBulkHoldDialog: boolean = false;
  bulkActionStatus: any;
  holdSelectedRecord: any[] = [];
  rejectSelectedRecord: any[] = [];
  displayReviewDialog: boolean = false; // Controls visibility of the dialog
  emailList: any[] = []; // Replace with your actual email list
  selectedEmail: string | null = null;
  selectedKey: string = 'DefaultKey'; // Or dynamically assigned
  reviewComment: string = '';
  submitted: boolean = false;
  brandName: string = '';
  caseNumber: string = '';
  ndaNumber: string = '';
  plaintiff: string = '';
  defendant: string = '';
  filedANDA: string = '';
  andaNumber: string = '';
  courtName: string = '';
  judgeName: string = '';
  filedDate: string = '';
  pdfFile: any | null = null;
  listPDFFile: File | null = null;
  editRowId: any;
  displayPatentDialog: boolean = false;
  selectedPatents: any;
  selectedRelatedCases: string[] = [];
  displayRelatedDialog: boolean = false;
  page = 1;
  pageSize = 10;
  totalRecords = 0;
  searchTerm = '';
  sortField: string | null = null;  // API expects the literal field label, e.g., "Field ID"
  sortOrder: number = 1;
  @ViewChild('litigationdata') litigationTable!: Table;
  searchScope: string = 'main';

  // litigation-dashboard.component.ts  (ADD THESE FIELDS)
  eventsMaster: { _id?: string; name: string }[] = [];
  displayEventManager = false;
  displayAddCaseEvent = false;
  displayViewCaseEvents = false;

  // "Event Manager" (add/update event names)
  newEventName = '';
  editEventId: string | null = null;
  editEventName = '';

  // "Add Case Event" per row
  activeCaseRow: any = null;
  caseEventDate: string = '';     // yyyy-mm-dd
  caseEventName: string = '';     // stores selected event name
  caseEventPdf: File | null = null;
  @ViewChild('caseEventFile') caseEventFile!: ElementRef<HTMLInputElement>;

  // "View Case Events"
  caseEventsForView: any[] = [];
  caseDetailsForView: any | null = null;

  // optional: simple in-page Events Filter (for Add dialog defaults / quick filtering)
  selectedEventFilter: string | null = null;
  eventFilterOptions: { label: string, value: string | null }[] = [{ label: 'All Events', value: null }];
  eventsOptions: { label: string; value: string }[] = [];

  // Appeal Event Manager
  appealEventsMaster: { _id?: string; name: string }[] = [];
  appealEventsOptions: { label: string; value: string }[] = [];
  displayAppealEventManager = false;
  newAppealEventName = '';
  editAppealEventId: string | null = null;
  editAppealEventName = '';

  displayUndoDialog: boolean = false;
  recordToUndo: any = null;

  editRowPdfMode: 'keep' | 'upload' | 'na' = 'keep';
  caseEventToDelete: any = null;
  displayDeleteCaseEventDialog: boolean = false;
  expandedRowKeys: { [key: string]: boolean } = {};

  // Appeal Case Addition
  displayAddAppealDialog: boolean = false;
  appealCaseNumber: string = '';
  appealCourt: string = '';
  appellantForm: string = '';
  appealFiledDate: string = '';
  appealCaseStatus: string = '';
  appealTerminationDate: string = '';
  appealPdfFile: File | null = null;
  activeAppealRow: any = null;
  appealStatusOptions = [
    { label: 'Open', value: 'Open' },
    { label: 'Closed', value: 'Closed' }
  ];
  appealTerminationDateMode: 'date' | 'na' = 'date';
  appealPdfMode: 'keep' | 'upload' | 'na' = 'keep';
  @ViewChild('appealFileInput') appealFileInput!: ElementRef<HTMLInputElement>;

  // Appeal Case Events
  displayAppealAddCaseEvent: boolean = false;
  displayAppealViewCaseEvents: boolean = false;
  appealCaseEventDate: string = '';
  appealCaseEventName: string = '';
  appealCaseEventPdf: File | null = null;
  activeAppealCase: any = null;
  parentCaseRow: any = null;
  appealCaseEventsForView: any[] = [];
  @ViewChild('appealCaseEventFile') appealCaseEventFile!: ElementRef<HTMLInputElement>;
  appealCaseEventToDelete: any = null;
  displayDeleteAppealCaseEventDialog: boolean = false;
  appealCaseDetailsForView: any = null;

  getAppealHeaders(appealCases: any[]): string[] {
    if (appealCases && appealCases.length > 0) {
      return Object.keys(appealCases[0]).filter(key => key !== '_id');
    }
    return [];
  }

  hasAppealCases(rowData: any): boolean {
    const appeals = rowData['AppealCases'];
    if (!appeals || appeals === 'N/A' || !Array.isArray(appeals)) return false;

    if ((this.selectedOption === 'appeal_cases' || this.selectedOption === 'other_litigation_appeal_cases') && this.selectedStatus === 'deleted') {
      return appeals.some(appeal => appeal['is_deleted'] === true);
    }
    return appeals.some(appeal => !appeal['is_deleted']);
  }

  getColSpan(): number {
    let colspan = 17; // Base columns ... now +1 for Add Appeal Case
    if (this.selectedStatus === 'pending') colspan += 2; // Reject, Approve
    if (this.selectedOption !== 'not_found_pdf_case_no' && this.selectedOption !== 'deleted') colspan += 1; // Edit
    if (this.selectedOption === 'deleted') colspan += 1; // Action
    return colspan;
  }

  constructor(
    private LitigationDashboardService: LitigationDashboardService,
    private toastService: ToastMessageService,
    private sanitized: DomSanitizer,
    private http: HttpClient,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.UserIp = localStorage.getItem('ipaddress');
    this.email = localStorage.getItem('email');
    // this.getlitigationData();
    this.loadEventMaster();
    this.loadAppealEventMaster();
    this.loadEaillitigationData();
  }

  getlitigationData() {
    this.loading = true;
    this.LitigationDashboardService.getEmailLitigationLogData(this.email).subscribe((response) => {
      this.litigationData = response["data"];
      this.litigationData.forEach(item => {
        item.filedDateObj = new Date(item['Field ID']);
      });
      console.log("litigationData", this.litigationData)
      this.filterLitigationData();
      this.loading = false;
    });
  }

  refreshData() {
    this.loading = true;
    this.page = 1;
    this.resetTableSortUI();
    // this.getlitigationData();
    this.loadEaillitigationData();
    this.loading = false;
  }

  onStartDateChange(event: any) {
    console.log("Start Date Changed:", event);
    this.startdate = event; // Update the startdate
    //   this.filterLitigationData(); // Trigger filtering
    this.resetTableSortUI();
    this.page = 1;
    this.loadEaillitigationData();
  }

  onEndDateChange(event: any) {
    console.log("End Date Changed:", event);
    this.enddate = event; // Update the enddate
    //  this.filterLitigationData(); // Trigger filtering
    this.resetTableSortUI();
    this.page = 1;
    this.loadEaillitigationData();
  }

  onOptionChange(event: any) {
    if (this.selectedOption === 'appeal_cases' || this.selectedOption === 'other_litigation_appeal_cases') {
      this.statusOptions = [
        { label: 'PENDING', value: 'pending' },
        { label: 'APPROVED', value: 'approved' },
        { label: 'DELETED', value: 'deleted' },
      ];
    } else {
      this.statusOptions = [
        { label: 'PENDING', value: 'pending' },
        { label: 'APPROVED', value: 'approved' },
        { label: 'REJECTED', value: 'rejected' },
      ];
    }

    // Reset status to pending if the current status is not valid for the new option
    const isValid = this.statusOptions.some(opt => opt.value === this.selectedStatus);
    if (!isValid) {
      this.selectedStatus = 'pending';
    }

    this.resetTableSortUI();
    this.page = 1;
    this.loadEaillitigationData();
  }

  onStatusChange(event: any) {
    this.selectedStatus = event.value; // Update the selected status
    // this.filterLitigationData();
    this.resetTableSortUI();
    this.page = 1;
    this.loadEaillitigationData();
  }

  showPatentDialog(row: any): void {
    const data = row['Patents at issue'];
    this.selectedPatents = Array.isArray(data) ? data : [];
    this.displayPatentDialog = true;
  }

  showRelatedCasesDialog(row: any): void {
    const data = row['Related Cases'];
    this.selectedRelatedCases = Array.isArray(data) ? data : [];
    this.displayRelatedDialog = true;
  }

  getFirstThreePatents(data: any): string[] {
    return Array.isArray(data) ? data.slice(0, 3) : [];
  }

  isArray(data: any): boolean {
    return Array.isArray(data) && data.length > 0;
  }

  onPDFSelect(event: any): void {
    const file = event.target.files[0];

    // Check if a file was selected
    if (file) {
      // Check if it's a PDF
      if (file.type === 'application/pdf') {
        const maxSize = 50 * 1024 * 1024;
        if (file.size <= maxSize) {
          this.pdfFile = file;
        } else {
          this.pdfFile = null;
          alert('File is too large. Please upload a PDF smaller than 50 MB.');
        }
      } else {
        this.pdfFile = null;
        alert('Only PDF files are allowed.');
      }
    } else {
      this.pdfFile = null;
    }
  }


  onListPDFSelect(event: any): void {
    const file = event.target.files[0];
    console.log("file 147", file)
    // Check if a file was selected
    if (file) {
      // Check if it's a PDF
      if (file.type === 'application/pdf') {
        const maxSize = 50 * 1024 * 1024;
        if (file.size <= maxSize) {
          this.listPDFFile = file;
          console.log("listPDFFile", this.listPDFFile)
        } else {
          this.listPDFFile = null;
          alert('File is too large. Please upload a PDF smaller than 50 MB.');
        }
      } else {
        this.listPDFFile = null;
        alert('Only PDF files are allowed.');
      }
    } else {
      this.listPDFFile = null;
    }
  }

  onAddLitigationTypeChange() {
    if (this.addLitigationType === 'other') {
      this.filedANDA = 'N/A';
      this.andaNumber = 'N/A';
    } else {
      if (this.filedANDA === 'N/A') this.filedANDA = '';
      if (this.andaNumber === 'N/A') this.andaNumber = '';
    }
  }

  confirmData(): void {
    if (this.loading) return;

    this.loading = true;

    const finalFiledANDA = this.addLitigationType === 'other' ? 'N/A' : (this.filedANDA || '');
    const finalANDANumber = this.addLitigationType === 'other' ? 'N/A' : (this.andaNumber || '');

    const formData = new FormData();
    formData.append('Brand Name', this.brandName);
    formData.append('Case Number', this.caseNumber);
    formData.append('NDA Number', this.ndaNumber);
    formData.append('Plaintiff', this.plaintiff);
    formData.append('ANDA Number', finalANDANumber);
    formData.append('Court Name', this.courtName);
    formData.append('Defendant', this.defendant);
    formData.append('Filed ANDA', finalFiledANDA);
    formData.append('Field ID', this.filedDate);
    formData.append('Judge', this.judgeName);
    if (this.pdfFile) {
      const originalName = this.pdfFile.name;
      const nameWithoutExtension = originalName.replace(/\.pdf$/i, ''); // Removes .pdf (case-insensitive)

      formData.append('pdf', this.pdfFile);
      formData.append('filename', nameWithoutExtension);
    }
    formData.append('user_ip', this.UserIp);
    formData.append('email', this.email);

    formData.append('Status', 'Manual Entry');
    formData.append('Source', this.addLitigationType);
    if (this.addLitigationType === 'other') {
      formData.append('Litigation Category', this.addLitigationCategory || 'NDA Vs NDA');
    }

    // Optional: Log keys/values for debugging
    formData.forEach((value, key) => {
      console.log(`${key}:`, value);
    });

    console.log(`Pdf filename :-`, this.pdfFile?.name);


    this.LitigationDashboardService.AddLitigationLogData(formData).subscribe({
      next: (response) => {
        console.log('Success:', response);
        //  this.getlitigationData();
        this.loadEaillitigationData();
        this.toastService.success(
          response['message'] || 'Records added successfully!'
        );
        this.displayReviewDialog = false;
        this.selectedLitigationData = [];
        this.loading = false;
        formData.append('Brand Name', this.brandName);
        this.brandName = "";
        this.caseNumber = "";
        this.ndaNumber = "";
        this.plaintiff = "";
        this.andaNumber = "";
        this.courtName = "";
        this.defendant = "";
        this.filedDate = "";
        this.filedANDA = "";
        this.pdfFile = "";
        const fileInput = document.getElementById('pdfUpload') as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }

        this.judgeName = "";
      },
      error: (err) => {
        console.error('Error:', err);
        this.toastService.error(
          'Error: ' + (err.error?.message || 'Something went wrong.')
        );
        this.loading = false;
      },
    });
  }

  filterLitigationData() {
    console.log("litigation data", this.litigationData);
    console.log("selectedOption", this.selectedOption);

    if (this.selectedOption === 'pdf') {
      this.filteredLitigationData = this.litigationData.filter(data => data['Status'] === 'Found in PDF' && !data['is_deleted'] && !data['onHold']);
      // this.showDeleteColumn = false;
      // console.log("this.filteredLitigationData", this.filteredLitigationData)
    } else if (this.selectedOption === 'not_found') {
      this.filteredLitigationData = this.litigationData.filter(data => data['Status'] === 'Not Found in PDF' && !data['is_deleted'] && !data['onHold'] && !(data['Case Number'] === '' && data['PDF File'] === 'N/A'));
      // this.showDeleteColumn = true;
      // console.log("this.filteredLitigationData", this.filteredLitigationData)
    } else if (this.selectedOption === 'defendants_directory') {
      this.filteredLitigationData = this.litigationData.filter(data => data['Status'] === 'Defendants Directory' && !data['is_deleted'] && !data['onHold']);
      // this.showDeleteColumn = true;
      // console.log("this.filteredLitigationData", this.filteredLitigationData)
    } else if (this.selectedOption === 'not_found_pdf_case_no') {
      this.filteredLitigationData = this.litigationData.filter(data => data['Case Number'] === '' && data['PDF File'] === 'N/A' && data['Status'] === 'Not Found in PDF' && !data['is_deleted']);
      // this.showDeleteColumn = true;
      // console.log("this.filteredLitigationData111", this.filteredLitigationData)
    } else if (this.selectedOption === 'Manual Entry') {
      this.filteredLitigationData = this.litigationData.filter(data => data['Status'] === 'Manual Entry' && !data['is_deleted'] && !data['onHold']);
      // this.showDeleteColumn = true;
      // console.log("this.filteredLitigationData111", this.filteredLitigationData)
    } else if (this.selectedOption === 'on_hold') {
      this.filteredLitigationData = this.litigationData.filter(data => data['onHold'] === true);
      // console.log("this.filteredLitigationData", this.filteredLitigationData)
    } else if (this.selectedOption === 'deleted') {
      this.filteredLitigationData = this.litigationData.filter(data => data['is_deleted'] === true);
      // console.log("this.filteredLitigationData", this.filteredLitigationData)
    } else if (this.selectedOption === 'Pre_2017_Litigation_Excel') {
      console.log(" litigation else if part0", this.filteredLitigationData);
      this.filteredLitigationData = this.litigationData.filter(data => data['Status'] === 'Found in PDF' && !data['is_deleted'] && ((data['Data Source'] || '') + '').replace(/\u00A0/g, ' ').trim().toLowerCase() === 'pre 2017 litigation excel');
      // this.showDeleteColumn = true;
      // console.log("this.filteredLitigationData111", this.filteredLitigationData)
    }
    console.log("Filtered Litigation Data", this.filteredLitigationData);
    if (this.selectedStatus) {
      this.filteredLitigationData = this.filteredLitigationData.filter(data => {
        const status = data['Approve/Reject Status'] ? data['Approve/Reject Status'].toLowerCase() : ''; // Ensure case insensitivity

        if (this.selectedStatus === 'pending') {
          return !status || status === 'pending';  // Handle null, undefined, or pending
        } else if (this.selectedStatus === 'approved') {
          return status === 'approved';
        } else if (this.selectedStatus === 'rejected') {
          return status === 'rejected';
        }
      });
    }

    if (this.startdate && this.enddate) {
      const start = new Date(this.startdate);
      const end = new Date(this.enddate);
      console.log("Datee", start, end);

      this.filteredLitigationData = this.filteredLitigationData.filter(data => {
        const recordDate = new Date(data['Field ID']);
        return recordDate >= start && recordDate <= end;
      });
    }

    if (this.startdate > this.enddate) {
      this.dateError = 'Please select a proper date range. Start date cannot be greater than end date.';
      return; // Prevent further execution
    } else {
      this.dateError = ''; // Clear the error
    }

    console.log("Filtered Litigation Data", this.filteredLitigationData);
  }

  // confirmBulkReject() {
  //   this.displayBulkRejectDialog = true;
  // }

  confirmBulkReject() {
    this.displayBulkRejectDialog = true;
  }

  confirmBulkHold() {
    this.displayBulkHoldDialog = true;
  }

  bulkHoldSelectedRecords() {
    if (this.selectedLitigationData && this.selectedLitigationData.length > 0) {
      const data = {
        records: this.selectedLitigationData.map(record => ({
          case_no: record['Case Number'],
          nda_no: record['NDA Number'],
          brand_name: record['Brand Name'],
          plaintiffs: record['Plaintiff'],
          pdf_file: record['PDF File'],
          _id: record['_id']
        })),
        which_action: 'on_hold', // Use the stored status
        user_ip: this.UserIp,
        email: this.email
      };

      console.log('Payload for Hold:', data);
      this.loading = true;
      this.LitigationDashboardService.LitigationOnHold(data).subscribe({
        next: response => {
          console.log('Bulk Hold API Response:', response);
          // this.getlitigationData();
          this.loadEaillitigationData();

          this.displayBulkHoldDialog = false;
          if (response['success'] && response['success'].length > 0) {
            this.toastService.success(`${response['success'].length} record(s) put on hold successfully!`);
          }
          // this.toastService.success(response['message'] || 'Records put on hold successfully!');
          if (response['failed'] && response['failed'].length > 0) {
            response['failed'].forEach((fail: any) => {
              const caseNo = fail.record?.case_no || 'Unknown';
              const brand = fail.record?.brand_name || 'Unknown';
              const reason = fail.reason || 'Unknown reason';
              this.toastService.error(`Failed to hold Case: ${caseNo}, Brand: ${brand}. Reason: ${reason}`);
            });
          }
          this.selectedLitigationData = [];
          this.loading = false;
        },
        error: err => {
          console.error('Error in bulk hold:', err);
          this.toastService.error('Error: ' + (err.error.message || 'Something went wrong. Please try again.'));
          this.loading = false;
        }
      });
      this.loading = false;
    }
  }


  rejectSelectedRecords() {
    if (this.selectedLitigationData && this.selectedLitigationData.length > 0) {
      console.log('Selected Records:', this.selectedLitigationData);

      // Create the payload with selected records and additional user info
      const data = {
        records: this.selectedLitigationData.map((record) => ({
          _id: record['_id'],
          case_no: record['Case Number'],
          nda_number: record['NDA Number'],
          brand_name: record['Brand Name'],
          plaintiff: record['Plaintiff'],
          filed_anda: Array.isArray(record['Filed ANDA']) ? record['Filed ANDA'].join(', ') : record['Filed ANDA'],
          anda_no: record['ANDA Number'],
          // You can add any additional fields needed from the record
        })),
        status: 'rejected',
        user_ip: this.UserIp,
        email: this.email
      };
      console.log('datadatadata', data);
      this.loading = true;
      this.LitigationDashboardService.LitigationApproveReject(data).subscribe(
        (response) => {
          console.log('API Response:', response);
          // this.getlitigationData();
          this.loadEaillitigationData();

          this.displayBulkRejectDialog = false;
          this.toastService.success(response['message'] || 'Data rejected successfully!');
          this.selectedLitigationData = [];
          this.loading = false;
        },
        (error) => {
          console.error('API Error:', error);
          this.toastService.error('Error: ' + (error.error.message || 'Something went wrong. Please try again.'));
          this.loading = false;
        }
      );
      this.loading = false;
    }
  }

  // Opens a confirmation dialog for bulk hold
  // confirmBulkHold() {
  //   this.displayBulkHoldDialog = true; // Add a variable in your component to control this dialog
  // }

  // Handles the bulk hold action
  // bulkHoldSelectedRecords() {
  //   if (this.selectedLitigationData && this.selectedLitigationData.length > 0) {
  //     const data = {
  //       records: this.selectedLitigationData.map(record => ({
  //         case_no: record['Case Number'],
  //         nda_no: record['NDA Number'],
  //         brand_name: record['Brand Name'],
  //         plaintiffs: record['Plaintiff'],
  //         pdf_file: record['PDF File'],
  //         id: record['id']
  //       })),
  //       which_action: 'on_hold',
  //       user_ip: this.UserIp,
  //       email: this.email
  //     };
  //     console.log("data", data)

  //     this.LitigationDashboardService.LitigationOnHold(data).subscribe({
  //       next: response => {
  //         console.log('Bulk Hold API Response:', response);
  //         this.loading = true;
  //         this.getlitigationData();
  //         this.loading = false;
  //         this.displayBulkHoldDialog = false;
  //         this.toastService.success(response['message'] || 'Records put on hold successfully!');
  //       },
  //       error: err => {
  //         console.error('Error in bulk hold:', err);
  //         this.toastService.error('Error: ' + (err.error.message || 'Something went wrong. Please try again.'));
  //       }
  //     });
  //   }
  // }

  confirmDelete(rowData: any) {
    this.recordToDelete = rowData;
    this.displayDeleteDialog = true;
  }

  deleteRecord() {
    let data: any = {
      // "case_no": this.recordToDelete['Case Number'],
      // "pdf_file": this.recordToDelete['PDF File'],
      "_id": this.recordToDelete['_id']
    };
    if (this.recordToDelete) {
      this.LitigationDashboardService.DeleteLitigationLogData(data).subscribe({
        next: response => {
          this.loading = true;
          console.log('Record deleted :', data);
          // this.getlitigationData();
          this.loadEaillitigationData();

          this.displayDeleteDialog = false;
          this.toastService.success('Data Deleted successfully!');
          // this.loading = false;
        },
        error: err => {
          console.error('Error deleting record:', err);
          this.toastService.error('Error deleting data. Please try again.');
          this.loading = false;
        }
      });
      this.loading = false;
    }
  }

  // confirmOnHold(rowData: any) {
  //   this.recordToHold = rowData;
  //   this.displayOnHoldDialog = true;
  // }

  // onHoldRecord() {
  //   let data: any = {
  //     "case_no": this.recordToHold['Case Number'],
  //     "nda_no": this.recordToHold['NDA Number'],
  //     "brand_name": this.recordToHold['Brand Name'],
  //     "plaintiffs": this.recordToHold['Plaintiff'],
  //     "pdf_file": this.recordToHold['PDF File'],
  //     "id": this.recordToHold['id']
  //   };

  //   if (this.recordToHold) {
  //     this.LitigationDashboardService.LitigationOnHold(data).subscribe({
  //       next: response => {
  //         console.log('Record onhold:', data);
  //         this.loading = true;
  //         this.getlitigationData();
  //         this.loading = false;
  //         this.displayOnHoldDialog = false;
  //         this.toastService.success('Record put on hold successfully!');
  //       },
  //       error: err => {
  //         console.error('Error putting record on hold:', err);
  //         this.toastService.error('Error putting record on hold. Please try again.');
  //       }
  //     });
  //   }
  // }

  onApproveReject(row_id, case_number: string, ndaNumber: string, brandName: string, plaintiff: string, filedANDA: string, andaNo: string, status: string, rowData: any): void {
    let data: any = {
      "_id": row_id,
      "case_no": case_number,
      "nda_number": ndaNumber,
      "brand_name": brandName,
      "plaintiff": plaintiff,
      "filed_anda": filedANDA,
      "anda_no": andaNo,
      "status": status,
      "user_ip": this.UserIp,
      "email": this.email,
    };
    console.log('Request Data:', ndaNumber, brandName, filedANDA, status, rowData);

    rowData.isButtonDisabled = true;

    this.LitigationDashboardService.LitigationApproveReject(data).subscribe((response) => {

      console.log('Response:', response);

      if (status === 'approved') {
        // rowData.status = 'Approved';
        this.toastService.success(response['message'] || 'Data approved successfully!');
      } else if (status === 'rejected') {
        // rowData.status = 'Rejected';
        this.toastService.success(response['message'] || 'Data rejected successfully!');
      }

      this.loading = true;
      // this.getlitigationData();
      this.loadEaillitigationData();

      this.loading = false;
    },
      (error) => {
        console.error('Error:', error);
        rowData.isButtonDisabled = false;
        this.toastService.error('Error: ' + (error.error.message || 'Something went wrong. Please try again.'));
        this.loading = false;
      }
    );
  }

  onAppealApproveReject(appeal: any, parentRow: any, status: string): void {
    let data: any = {
      "_id": parentRow['_id'],
      "appeal_case_number": appeal['Appeal Case Number'],
      "status": status,
      "email": this.email,
    };

    console.log('Appeal Approve/Reject Request Data:', data);

    appeal.isButtonDisabled = true;

    this.LitigationDashboardService.appealApproveReject(data).subscribe(
      (response) => {
        console.log('Appeal Response:', response);
        this.toastService.success(response['message'] || `Appeal ${status} successfully!`);
        this.loading = true;
        this.loadEaillitigationData();
        this.loading = false;
      },
      (error) => {
        console.error('Error:', error);
        appeal.isButtonDisabled = false;
        this.toastService.error('Error: ' + (error.error?.message || 'Something went wrong. Please try again.'));
      }
    );
  }

  // getlitigationData() {
  //   this.LitigationDashboardService.getEmailLitigationLogData().subscribe((response) => {
  //     this.litigationData = response["data"];
  //     console.log("resss", this.litigationData);
  //     this.loading = false;

  //   });
  // }

  clearDates() {
    this.startdate = undefined;
    this.enddate = undefined;
    //this.filterLitigationData();
    this.resetTableSortUI();
    this.page = 1;
    this.loadEaillitigationData();
  }
  onSearchChange(val: string) {
    this.searchTerm = val || '';
    this.resetTableSortUI();
    this.page = 1;
    this.loadEaillitigationData();
  }

  openPdf(value: any) {
    if (!value) return;
    const cacheBuster = `?t=${new Date().getTime()}`;
    const url = `${environment.apiServer}/${value}${cacheBuster}`;
    window.open(url, '_blank');
  }

  openDialog() {
    this.submitted = false;
    this.selectedEmail = null;
    this.reviewComment = '';
    this.addLitigationType = 'main';
    this.addLitigationCategory = 'NDA Vs NDA';
    this.displayReviewDialog = true;
  }
  viewAllRecords() {
    this.router.navigate(['/view-all-litigation-complaints']);
  }

  editRow(rowData: any) {
    this.editRowId = rowData['_id'];
    this.listPDFFile = null;

    this.editRowPdfMode = (rowData['PDF File'] === 'N/A' || !rowData['PDF File'])
      ? 'na'
      : 'keep';
  }
  saveRow(rowData: any) {
    console.log("rowData", rowData);

    const formData = new FormData();

    const excludeKeys = [
      'pdf', 'PDF File',
      'Litigation_Category', 'litigation_category', 'Data_Source', 'data_source'
    ];

    for (const key in rowData) {
      if (rowData[key] && !excludeKeys.includes(key)) {
        formData.append(key, rowData[key]);
      }
    }

    if (this.email) {
      formData.append('email', this.email);
    }

    const category = rowData['Litigation_Category'] || '';
    if (category) {
      formData.set('Litigation Category', category);
    }

    const dataSource = rowData['Data Source'] || rowData['Data_Source'] || '';
    if (dataSource) {
      formData.set('Data Source', dataSource);
    }


    if (this.editRowPdfMode === 'na') {
      formData.append('PDF File', 'N/A');

    } else if (this.editRowPdfMode === 'upload') {
      if (!this.listPDFFile) {
        this.toastService.error('Please select a PDF file to upload.');
        return; // block save until file is chosen
      }
      const nameWithoutExtension = this.listPDFFile.name.replace(/\.pdf$/i, '');
      formData.append('pdf', this.listPDFFile);
      formData.append('filename', nameWithoutExtension);
    } else if (this.editRowPdfMode === 'keep') {
      formData.append('PDF File', rowData['PDF File']);
    }

    // Call the service with FormData
    this.LitigationDashboardService.saveLitigationLogData(formData).subscribe(
      (response) => {
        console.log("response", response);
        this.toastService.success(response['message'] || 'Data saved successfully!');
        //  this.getlitigationData();
        this.loadEaillitigationData();

        this.editRowId = null;
        this.listPDFFile = null;

        this.editRowPdfMode = 'keep';
      },
      (error) => {
        console.error('Error:', error);
        this.toastService.error('Error: ' + (error.error.message || 'Something went wrong. Please try again.'));
        this.loading = false;
      }
    );
  }

  private toMMDDYYYY(d?: Date) {
    if (!d) return undefined;
    const mm = (d.getMonth() + 1).toString().padStart(2, '0');
    const dd = d.getDate().toString().padStart(2, '0');
    return `${mm}/${dd}/${d.getFullYear()}`;
  }

  loadEaillitigationData() {
    if (this.startdate && this.enddate && this.startdate > this.enddate) {
      this.dateError = 'Please select a proper date range. Start date cannot be greater than end date.';
      return;
    } else this.dateError = '';

    let selected_event_id = 'all';
    if (this.selectedEventFilter && this.selectedEventFilter.trim()) {
      const ev = this.eventsMaster.find(e =>
        e.name === this.selectedEventFilter ||
        String((e as any).id ?? e._id) === String(this.selectedEventFilter)
      );
      selected_event_id = String((ev as any)?.id ?? (ev as any)?._id ?? this.selectedEventFilter);
    }

    this.loading = true;
    this.LitigationDashboardService.getEmailLitigationDataPaged({
      user_email: this.email,
      selected_option: this.selectedOption,
      selected_status: this.selectedStatus,
      start_date: this.toMMDDYYYY(this.startdate),
      end_date: this.toMMDDYYYY(this.enddate),
      search: this.searchTerm,
      page: this.page,
      page_size: this.pageSize,
      sort_field: this.sortField || undefined,   // e.g., "Field ID" / "Case Status" / "Termination Date"
      sort_order: this.sortOrder || undefined,
      selected_event_id,
      search_scope: this.searchScope.toLowerCase(),
      deleted_scope: this.selectedOption === 'deleted' ? this.deletedScope : undefined
    }).subscribe({
      next: (res) => {
        this.litigationData = res?.["data"] || [];
        this.litigationData.forEach(x => x.filedDateObj = new Date(x['Field ID']));
        this.filteredLitigationData = this.litigationData;  // keep table binding
        this.totalRecords = res?.["total"] ?? this.filteredLitigationData.length;
        this.loading = false;
      },
      error: () => { this.filteredLitigationData = []; this.totalRecords = 0; this.loading = false; }
    });
  }

  onPage(e: { first: number; rows: number }) {
    this.pageSize = e.rows ?? this.pageSize;
    this.page = Math.floor((e.first ?? 0) / this.pageSize) + 1; // <-- use first/rows
    this.loadEaillitigationData();
  }

  onLazyLoad(e: LazyLoadEvent) {
    // Update paging
    this.pageSize = e.rows ?? this.pageSize;
    this.page = Math.floor((e.first ?? 0) / this.pageSize) + 1;

    // Update sorting (PrimeNG gives these when header is clicked)
    this.sortField = (e.sortField as string) ?? null;
    // Normalize undefined to 1 (asc)
    this.sortOrder = typeof e.sortOrder === 'number' ? e.sortOrder : 1;

    this.loadEaillitigationData();
  }

  private resetTableSortUI() {
    // reset bound inputs
    this.sortField = null;
    this.sortOrder = 1;

    // reset PrimeNG internal sort state directly without triggering clear() callback loop
    if (this.litigationTable) {
      this.litigationTable.sortField = undefined;
      this.litigationTable.sortOrder = 1;
    }
  }

  private loadEventMaster() {
    this.LitigationDashboardService.getAllEvents().subscribe({
      next: (res) => {
        // ✅ Type-safe runtime check
        const raw = (res && 'data' in res) ? (res as any).data : res as any[];

        // Normalize to consistent format from API response:
        // { data: [{ id: number, event_text: string }, ...] }
        this.eventsMaster = (raw || []).map((x: any) => ({
          _id: String(x.id),
          name: x.event_text
        }));

        // Build dropdown/filter options
        this.eventFilterOptions = [
          { label: 'All Events', value: null },
          ...this.eventsMaster.map(e => ({ label: e.name, value: e.name }))
        ];

        this.eventsOptions = this.eventsMaster.map(e => ({
          label: e.name,
          value: e.name
        }));
      },
      error: () => {
        this.eventsMaster = [];
        this.eventFilterOptions = [{ label: 'All Events', value: null }];
        this.eventsOptions = [];
      }
    });
  }



  openEventManager() {
    this.newEventName = '';
    this.editEventId = null;
    this.editEventName = '';
    this.displayEventManager = true;
  }

  addNewEventName() {
    const name = (this.newEventName || '').trim();
    if (!name) return this.toastService.error('Please enter an event name.');
    this.LitigationDashboardService.addNewEvent(name, this.email || 'system').subscribe({
      next: (r) => {
        this.toastService.success(r?.message || 'Event added.');
        this.newEventName = '';
        this.loadEventMaster();
      },
      error: (e) => this.toastService.error(e?.error?.message || 'Failed to add event.')
    });
  }

  startEditEvent(ev: { _id?: string; name: string }) {
    this.editEventId = ev._id || '';
    this.editEventName = ev.name;
  }


  saveEditEvent() {
    const id = this.editEventId || '';
    const nm = (this.editEventName || '').trim();
    if (!id || !nm) {
      this.toastService.error('Please provide event text.');
      return;
    }

    this.LitigationDashboardService
      .updateEventName(id, nm, this.email || 'system')
      .subscribe({
        next: (r) => {
          this.toastService.success(r?.message || 'Event updated.');
          this.editEventId = null;
          this.editEventName = '';
          this.loadEventMaster();
        },
        error: (e) => this.toastService.error(e?.error?.message || 'Failed to update event.')
      });
  }

  // --- APPEAL EVENT MANAGER ---
  private loadAppealEventMaster() {
    this.LitigationDashboardService.getAllAppealEvents().subscribe({
      next: (res) => {
        const raw = (res && 'data' in res) ? (res as any).data : res as any[];
        this.appealEventsMaster = (raw || [])
          .filter((x: any) => !x.is_deleted)
          .map((x: any) => ({
            _id: String(x.id),
            name: x.event_text
          }));

        this.appealEventsOptions = this.appealEventsMaster.map(e => ({
          label: e.name,
          value: e.name
        }));
      },
      error: () => {
        this.appealEventsMaster = [];
      }
    });
  }

  openAppealEventManager() {
    this.newAppealEventName = '';
    this.editAppealEventId = null;
    this.editAppealEventName = '';
    this.displayAppealEventManager = true;
  }

  addNewAppealEventName() {
    const name = (this.newAppealEventName || '').trim();
    if (!name) return this.toastService.error('Please enter an event name.');
    this.LitigationDashboardService.addAppealEvent(name, this.email || 'system').subscribe({
      next: (r) => {
        this.toastService.success(r?.message || 'Appeal event added.');
        this.newAppealEventName = '';
        this.loadAppealEventMaster();
      },
      error: (e) => this.toastService.error(e?.error?.message || 'Failed to add appeal event.')
    });
  }

  startEditAppealEvent(ev: { _id?: string; name: string }) {
    this.editAppealEventId = ev._id || '';
    this.editAppealEventName = ev.name;
  }

  saveEditAppealEvent() {
    const id = this.editAppealEventId || '';
    const nm = (this.editAppealEventName || '').trim();
    if (!id || !nm) {
      this.toastService.error('Please provide appeal event text.');
      return;
    }

    this.LitigationDashboardService
      .renameAppealEvent(id, nm, this.email || 'system')
      .subscribe({
        next: (r) => {
          this.toastService.success(r?.message || 'Appeal event updated.');
          this.editAppealEventId = null;
          this.editAppealEventName = '';
          this.loadAppealEventMaster();
        },
        error: (e) => this.toastService.error(e?.error?.message || 'Failed to update appeal event.')
      });
  }


  openAddCaseEvent(row: any) {
    this.activeCaseRow = row;
    this.caseEventDate = '';         // force user choose date
    this.caseEventName = this.selectedEventFilter ?? ''; // default from filter if set
    this.caseEventPdf = null;
    this.displayAddCaseEvent = true;
  }

  onCaseEventPdfPicked(e: any) {
    const f = e?.target?.files?.[0];
    if (!f) { this.caseEventPdf = null; return; }
    if (f.type !== 'application/pdf') {
      this.toastService.error('Only PDF allowed.');
      return;
    }
    const max = 50 * 1024 * 1024;
    if (f.size > max) {
      this.toastService.error('PDF must be ≤ 50MB.');
      return;
    }
    this.caseEventPdf = f;
  }

  openViewCaseEvents(row: any) {
    this.activeCaseRow = row;
    this.caseDetailsForView = null;
    this.caseEventsForView = [];
    this.displayViewCaseEvents = true;

    this.LitigationDashboardService.viewCaseEvents(row['_id']).subscribe({
      next: (res) => {
        // Handle either {case_details, events} or {data: {case_details, events}}
        const payload =
          (res as any)?.data ? (res as any).data : (res as any);

        this.caseDetailsForView = payload?.case_details ?? null;
        this.caseEventsForView = (payload?.events || []).filter((e: any) => !e.is_deleted);
      },
      error: () => {
        this.caseDetailsForView = null;
        this.caseEventsForView = [];
      }
    });
  }


  openCaseEventPdf(pathOrUrl: string) {
    if (!pathOrUrl) return;
    // If backend sometimes returns a full URL, open directly.
    const isAbsolute = /^https?:\/\//i.test(pathOrUrl);
    const url = isAbsolute ? pathOrUrl : `${environment.ip}pm_backend/${pathOrUrl}`;
    window.open(url, '_blank');
  }


  // litigation-dashboard.component.ts (helper)
  private toMMDDYYYYfromISO(isoLike: string) {
    // Accepts 'yyyy-mm-dd' or Date string; returns 'MM/DD/YYYY'
    const d = new Date(isoLike);
    if (Number.isNaN(d.getTime())) return isoLike; // fallback, keep raw
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${mm}/${dd}/${d.getFullYear()}`;
  }

  // Replace your saveCaseEvent() with this
  saveCaseEvent() {
    if (!this.activeCaseRow?._id) return this.toastService.error('Invalid case.');
    if (!this.caseEventDate) return this.toastService.error('Select a date.');
    if (!this.caseEventName) return this.toastService.error('Select an event.');
    //   if (!this.caseEventPdf) return this.toastService.error('Attach a PDF.');

    // Resolve event_id from eventsMaster (supports if dropdown stores text or id)
    const ev = this.eventsMaster.find(e =>
      e.name === this.caseEventName || String((e as any).id ?? e._id) === String(this.caseEventName)
    );
    const eventId: string =
      String((ev as any)?.id ?? (ev as any)?._id ?? this.caseEventName); // final event_id as string

    // Build FormData EXACTLY as in Postman
    const fd = new FormData();
    fd.append('case_number', this.activeCaseRow['Case Number'] ?? '');
    fd.append('event_id', eventId);
    fd.append('event_date', this.toMMDDYYYYfromISO(this.caseEventDate)); // e.g. 11/11/2025
    fd.append('attachment', this.caseEventPdf); // file

    fd.append('_id', this.activeCaseRow['_id'] ?? '');
    fd.append('nda_number', this.activeCaseRow['NDA Number'] ?? '');
    fd.append('brand_name', this.activeCaseRow['Brand Name'] ?? '');
    fd.append('plaintiff_name', this.activeCaseRow['Plaintiff'] ?? '');

    // (Optional) if backend also accepts who added:
    // if (this.email) fd.append('email', this.email);
    // if (this.UserIp) fd.append('user_ip', this.UserIp);

    this.LitigationDashboardService.addCaseEvent(fd).subscribe({
      next: (r) => {
        this.toastService.success(r?.message || 'New event added successfully.');
        if (this.caseEventFile) this.caseEventFile.nativeElement.value = '';
        this.caseEventPdf = null;
        this.caseEventName = '';
        this.caseEventDate = '';
        this.displayAddCaseEvent = false;
        this.activeCaseRow = null;
        this.caseEventPdf = null;
        // optional: refresh list
        // this.loadEaillitigationData();
      },
      error: (e) => this.toastService.error(e?.error?.message || 'Failed to add event.')
    });
  }

  getAndaLines(value: any): string[] {
    if (!value) return [];

    // If already array
    if (Array.isArray(value)) {
      return value
        .map(x => String(x).trim())
        .filter(Boolean);
    }

    // If string: split by comma/newline and trim
    const s = String(value)
      .replace(/\r?\n/g, ',')     // newlines -> comma
      .replace(/\s+/g, ' ')      // collapse spaces
      .trim();

    return s
      .split(',')
      .map(x => x.trim())
      .filter(Boolean);
  }

  confirmUndo(rowData: any) {
    this.recordToUndo = rowData;
    this.displayUndoDialog = true;
  }

  undoDeletedRecord() {
    if (!this.recordToUndo?._id) return;

    const payload = {
      _id: this.recordToUndo._id,
      undo: true,
      user_email: this.email
    };

    this.loading = true;

    this.LitigationDashboardService.undoDeletedRecord(payload).subscribe({
      next: (res) => {
        this.toastService.success(res?.message || 'Record restored successfully');
        this.displayUndoDialog = false;
        this.recordToUndo = null;
        this.loadEaillitigationData();
        this.loading = false;
      },
      error: (err) => {
        this.toastService.error(err?.error?.message || 'Undo failed');
        this.loading = false;
      }
    });
  }

  confirmDeleteCaseEvent(event: any) {
    this.caseEventToDelete = event;
    this.displayDeleteCaseEventDialog = true;
  }

  deleteCaseEvent() {
    if (!this.caseEventToDelete?.event_id) return;

    const payload = {
      _id: this.activeCaseRow?._id,
      event_id: this.caseEventToDelete.event_id,
      user_email: this.email
    };

    // show spinner while waiting
    this.loading = true;

    this.LitigationDashboardService.deleteCaseEvent(payload).subscribe({
      next: (res) => {
        this.toastService.success(res?.message || 'Case event deleted successfully');

        // hide the confirmation popup
        this.displayDeleteCaseEventDialog = false;
        this.caseEventToDelete = null;
        this.displayViewCaseEvents = false;
        this.loadEaillitigationData();

        this.loading = false;
      },
      error: (err) => {
        this.toastService.error(err?.error?.message || 'Failed to delete case event');
        this.loading = false;
      }
    });
  }

  // --- ADD/EDIT/DELETE APPEAL CASE LOGIC ---
  isEditAppeal: boolean = false;
  activeAppealToEdit: any = null;
  displayDeleteAppealDialog: boolean = false;
  appealToDelete: any = null;
  displayUndoAppealDialog: boolean = false;
  appealToUndo: any = null;

  openAddAppealCase(row: any) {
    this.isEditAppeal = false;
    this.activeAppealToEdit = null;
    this.activeAppealRow = row;
    this.appealCaseNumber = '';
    this.appealCourt = '';
    this.appellantForm = '';
    this.appealFiledDate = '';
    this.appealCaseStatus = '';
    this.appealTerminationDate = '';
    this.appealPdfFile = null;
    this.appealTerminationDateMode = 'date';
    this.appealPdfMode = 'upload';
    if (this.appealFileInput) {
      this.appealFileInput.nativeElement.value = '';
    }
    this.displayAddAppealDialog = true;
  }

  onAppealStatusChange() {
    if (this.appealCaseStatus === 'Open') {
      this.appealTerminationDateMode = 'na';
      this.appealTerminationDate = 'N/A';
    } else if (this.appealCaseStatus === 'Closed') {
      this.appealTerminationDateMode = 'date';
      if (this.appealTerminationDate === 'N/A' || !this.appealTerminationDate) {
        this.appealTerminationDate = '';
      }
    }
  }

  editAppealCase(appeal: any, parentRow: any) {
    this.isEditAppeal = true;
    this.activeAppealToEdit = appeal;
    this.activeAppealRow = parentRow;

    this.appealCaseNumber = appeal['Appeal Case Number'] || '';
    this.appealCourt = appeal['Appeal Court'] || '';
    this.appellantForm = appeal['Appellant'] || '';
    // Dates might need conversion back to ISO if they are stored as MMDDYYYY
    this.appealFiledDate = this.toISOFromMMDDYYYY(appeal['Appeal Filed Date']);
    this.appealCaseStatus = appeal['Appeal Case Status'] || '';
    this.appealTerminationDate = appeal['Appeal Termination Date'] || ''; // usually YYYY-MM-DD

    // Set mode based on status if defined, otherwise fall back to current value
    if (this.appealCaseStatus === 'Open') {
      this.appealTerminationDateMode = 'na';
      this.appealTerminationDate = 'N/A';
    } else if (this.appealCaseStatus === 'Closed') {
      this.appealTerminationDateMode = 'date';
      if (this.appealTerminationDate === 'N/A' || !this.appealTerminationDate) {
        this.appealTerminationDate = '';
      }
    } else {
      if (this.appealTerminationDate === 'N/A' || !this.appealTerminationDate) {
        this.appealTerminationDateMode = 'na';
        this.appealTerminationDate = 'N/A';
      } else {
        this.appealTerminationDateMode = 'date';
      }
    }

    if (appeal['Appeal PDF Path'] === 'N/A' || !appeal['Appeal PDF Path']) {
      this.appealPdfMode = 'na';
    } else {
      this.appealPdfMode = 'keep';
    }

    this.appealPdfFile = null;
    if (this.appealFileInput) {
      this.appealFileInput.nativeElement.value = '';
    }
    this.displayAddAppealDialog = true;
  }

  confirmDeleteAppeal(appeal: any, parentRow: any) {
    this.appealToDelete = { appeal, parentRow };
    this.displayDeleteAppealDialog = true;
  }

  deleteAppealCase() {
    if (!this.appealToDelete) return;
    this.loading = true;
    const { appeal, parentRow } = this.appealToDelete;

    const payload = {
      _id: parentRow['_id'],
      case_number: parentRow['Case Number'] || '',
      nda_number: parentRow['NDA Number'] || '',
      brand_name: parentRow['Brand Name'] || '',
      "Appeal Case Number": appeal['Appeal Case Number'] || '',
      deleted_by: this.email || 'system'
    };

    this.LitigationDashboardService.deleteAppealCase(payload).subscribe({
      next: (res) => {
        this.toastService.success(res?.message || 'Appeal case deleted successfully');
        this.displayDeleteAppealDialog = false;
        this.loading = false;
        this.loadEaillitigationData();
      },
      error: (err) => {
        this.toastService.error(err?.error?.message || 'Error deleting appeal case.');
        this.loading = false;
      }
    });
  }

  private toISOFromMMDDYYYY(dateStr: string): string {
    if (!dateStr || !dateStr.includes('/')) return dateStr;
    const parts = dateStr.split('/');
    if (parts.length !== 3) return dateStr;
    // MM/DD/YYYY -> YYYY-MM-DD
    return `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
  }

  onAppealPdfSelect(event: any) {
    const file = event.target.files[0];
    if (file) {
      if (file.type === 'application/pdf') {
        const maxSize = 50 * 1024 * 1024;
        if (file.size <= maxSize) {
          this.appealPdfFile = file;
        } else {
          this.appealPdfFile = null;
          this.toastService.error('File size exceeds 50MB.');
        }
      } else {
        this.appealPdfFile = null;
        this.toastService.error('Please select a PDF file.');
      }
    }
  }

  saveAppealCase() {
    if (!this.appealCaseNumber || !this.appealCourt || !this.appellantForm) {
      this.toastService.error('Please fill required fields.');
      return;
    }

    this.loading = true;
    const formData = new FormData();
    // Base row data
    formData.append('_id', this.activeAppealRow['_id'] || '');
    formData.append('case_number', this.activeAppealRow['Case Number'] || '');
    formData.append('nda_number', this.activeAppealRow['NDA Number'] || '');
    formData.append('brand_name', this.activeAppealRow['Brand Name'] || '');

    if (this.isEditAppeal && this.activeAppealToEdit) {
      formData.append('appeal_case_number', this.activeAppealToEdit['Appeal Case Number'] || '');
      formData.append('updated_by', this.email || 'system');
    } else {
      formData.append('added_by', this.email || 'system');
    }

    // Appeal Case details (exactly as provided in payload)
    formData.append('Appeal Case Number', this.appealCaseNumber);
    formData.append('Appeal Court', this.appealCourt);
    formData.append('Appellant', this.appellantForm);

    // Handle Termination Date
    if (this.appealTerminationDateMode === 'na') {
      formData.append('Appeal Termination Date', 'N/A');
    } else {
      formData.append('Appeal Termination Date', this.appealTerminationDate);
    }

    formData.append('Appeal Filed Date', this.toMMDDYYYYfromISO(this.appealFiledDate));
    formData.append('Appeal Case Status', this.appealCaseStatus);

    // Handle PDF
    if (this.appealPdfMode === 'na') {
      formData.append('Appeal PDF Path', 'N/A');
    } else if (this.appealPdfMode === 'upload') {
      if (this.appealPdfFile) {
        formData.append('appeal_pdf', this.appealPdfFile);
      } else {
        // If they chose upload but didn't pick a file, and it was previously N/A, keep it N/A
        // Or if they are adding new, maybe it should be N/A
        if (!this.isEditAppeal) {
          formData.append('Appeal PDF Path', 'N/A');
        } else {
          // If editing and chose upload but no file, what was the intent?
          // Usually we should require a file if 'upload' is selected.
          // For now, let's just not append anything or append N/A if missing.
          formData.append('Appeal PDF Path', this.activeAppealToEdit['Appeal PDF Path'] || 'N/A');
        }
      }
    } else if (this.appealPdfMode === 'keep' && this.isEditAppeal) {
      formData.append('Appeal PDF Path', this.activeAppealToEdit['Appeal PDF Path'] || 'N/A');
    }

    const obs = this.isEditAppeal ?
      this.LitigationDashboardService.updateAppealCase(formData) :
      this.LitigationDashboardService.addAppealCase(formData);

    obs.subscribe({
      next: (res) => {
        const actionText = this.isEditAppeal ? 'updated' : 'added';
        this.toastService.success(res?.message || `Appeal case ${actionText} successfully!`);
        this.displayAddAppealDialog = false;
        this.loading = false;
        this.loadEaillitigationData(); // Refresh to show the new/updated appeal case in nested table
      },
      error: (err) => {
        this.toastService.error(err?.error?.message || `Error saving appeal case.`);
        this.loading = false;
      }
    });
  }

  confirmUndoAppeal(appeal: any, parentRow: any) {
    this.appealToUndo = { appeal, parentRow };
    this.displayUndoAppealDialog = true;
  }

  undoAppealCase() {
    if (!this.appealToUndo) return;
    this.loading = true;
    const { appeal, parentRow } = this.appealToUndo;

    const payload = {
      _id: parentRow['_id'],
      case_number: parentRow['Case Number'] || '',
      nda_number: parentRow['NDA Number'] || '',
      brand_name: parentRow['Brand Name'] || '',
      "Appeal Case Number": appeal['Appeal Case Number'] || '',
      undo: true,
      restored_by: this.email || 'system'
    };

    this.LitigationDashboardService.undoAppealCase(payload).subscribe({
      next: (res) => {
        this.toastService.success(res?.message || 'Appeal case restored successfully');
        this.displayUndoAppealDialog = false;
        this.appealToUndo = null;
        this.loading = false;
        this.loadEaillitigationData();
      },
      error: (err) => {
        this.toastService.error(err?.error?.message || 'Error restoring appeal case.');
        this.loading = false;
      }
    });
  }

  getFilteredAppeals(appeals: any[]): any[] {
    if (!appeals) return [];
    if ((this.selectedOption === 'appeal_cases' || this.selectedOption === 'other_litigation_appeal_cases') && this.selectedStatus === 'deleted') {
      return appeals.filter(appeal => appeal['is_deleted'] === true);
    }
    return appeals.filter(appeal => !appeal['is_deleted']);
  }

  // --- APPEAL CASE EVENT METHODS ---
  openAddAppealCaseEvent(appeal: any, parentRow: any) {
    this.activeAppealCase = appeal;
    this.parentCaseRow = parentRow;
    this.appealCaseEventDate = '';
    this.appealCaseEventName = '';
    this.appealCaseEventPdf = null;
    this.displayAppealAddCaseEvent = true;
  }

  onAppealCaseEventPdfPicked(e: any) {
    const f = e?.target?.files?.[0];
    if (!f) { this.appealCaseEventPdf = null; return; }
    if (f.type !== 'application/pdf') {
      this.toastService.error('Only PDF allowed.');
      return;
    }
    this.appealCaseEventPdf = f;
  }

  saveAppealCaseEvent() {
    if (!this.appealCaseEventDate) return this.toastService.error('Select a date.');
    if (!this.appealCaseEventName) return this.toastService.error('Select an event.');

    const ev = this.appealEventsMaster.find(e =>
      e.name === this.appealCaseEventName || String(e._id) === String(this.appealCaseEventName)
    );
    const eventId = String(ev?._id ?? this.appealCaseEventName);

    const fd = new FormData();
    fd.append('_id', this.parentCaseRow['_id'] || '');
    fd.append('appeal_case_number', this.activeAppealCase['Appeal Case Number'] || '');
    fd.append('event_id', eventId);
    fd.append('event_date', this.toMMDDYYYYfromISO(this.appealCaseEventDate));
    if (this.appealCaseEventPdf) {
      fd.append('attachment', this.appealCaseEventPdf);
    }

    this.LitigationDashboardService.addAppealCaseEvent(fd).subscribe({
      next: (r) => {
        this.toastService.success(r?.message || 'New appeal event added.');
        this.displayAppealAddCaseEvent = false;
        if (this.appealCaseEventFile) this.appealCaseEventFile.nativeElement.value = '';
      },
      error: (e) => this.toastService.error(e?.error?.message || 'Failed to add appeal event.')
    });
  }

  openViewAppealCaseEvents(appeal: any, parentRow: any) {
    this.activeAppealCase = appeal;
    this.parentCaseRow = parentRow;
    this.appealCaseEventsForView = [];
    this.displayAppealViewCaseEvents = true;

    this.LitigationDashboardService.viewAppealCaseEvents(parentRow['_id'], appeal['Appeal Case Number']).subscribe({
      next: (res) => {
        // Handle different response structures gracefully
        let events = [];
        if (res && (res as any).data) {
          const data = (res as any).data;
          if (Array.isArray(data)) {
            events = data;
          } else if (data.events && Array.isArray(data.events)) {
            events = data.events;
            this.appealCaseDetailsForView = data.case_details || null;
          }
        } else if (Array.isArray(res)) {
          events = res;
        }

        this.appealCaseEventsForView = events.filter((e: any) => !e.is_deleted);
      },
      error: () => {
        this.appealCaseEventsForView = [];
      }
    });
  }

  confirmDeleteAppealCaseEvent(ev: any) {
    this.appealCaseEventToDelete = ev;
    this.displayDeleteAppealCaseEventDialog = true;
  }

  deleteAppealCaseEvent() {
    if (!this.appealCaseEventToDelete) return;
    const payload = {
      _id: this.parentCaseRow['_id'],
      appeal_case_number: this.activeAppealCase['Appeal Case Number'],
      event_id: this.appealCaseEventToDelete.event_id,
      user_email: this.email || 'system'
    };

    this.LitigationDashboardService.deleteAppealCaseEvent(payload).subscribe({
      next: (r) => {
        this.toastService.success(r?.message || 'Appeal event deleted.');
        this.displayDeleteAppealCaseEventDialog = false;
        // Refresh the events list
        this.openViewAppealCaseEvents(this.activeAppealCase, this.parentCaseRow);
      },
      error: (e) => this.toastService.error(e?.error?.message || 'Failed to delete appeal event.')
    });
  }
}

